import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import Card from './components/AgendaContent/Card';
import config from './Config';

if (document.body.contains(document.querySelector('.js_react_filter'))) {
	document.querySelectorAll(".js_react_filter").forEach((filter, index) => {
		ReactDOM.render(
				<App key={index} config={config} rootElement={filter} />,
			filter
		);
	});
}

if (document.body.contains(document.querySelector('.js_react_tile'))) {
  	document.querySelectorAll('.js_react_tile').forEach((tile, index) => {
    	let event = Object.values(JSON.parse(decodeURIComponent(tile.dataset.event)))[0];

		ReactDOM.render(
			<Card
				element={event}
				config={config.goudse}
				setTagsParam={function () {
					return;
				}}
			/>,
			tile
		);
  });
};
